<ng-container [formGroup]="parent">
    <nz-form-item>
        <nz-form-label nzRequired [nzSpan]="24">
            {{ 'relation-relation.fields.related-relation' | translate }}
        </nz-form-label>
        <nz-form-control [nzSpan]="24" [nzErrorTip]="relationIdValidationTemplate">
            <nz-select
                formControlName="relatedRelationId"
                (nzScrollToBottom)="loadMore()"
                (nzOnSearch)="inputSearch($event)"
                nzPlaceHolder="{{ 'relation-relation.modal.related-relation' | translate }}"
                nzShowSearch
                class="w-100">
                <nz-option-group
                    nzLabel="{{ 'relation-relation.modal.relation' | translate }}"
                    *ngIf="relationList.length > 0">
                    <nz-option
                        *ngFor="let entry of relationList"
                        [nzValue]="entry.key"
                        nzCustomContent
                        [nzLabel]="entry.value">
                        {{ entry.value }}
                    </nz-option>
                </nz-option-group>
            </nz-select>
            <ng-template #relationIdValidationTemplate let-control>
                <app-input-validation [control]="control" [field]="'relatedRelationId'"></app-input-validation>
            </ng-template>
        </nz-form-control>
    </nz-form-item>
</ng-container>
